import debug from 'debug';

import request from './request';

const log = debug('huddle:api:huddle-request');

// TODO: refactor to global/env/config
const { API_HOST = 'api-dev.thehuddle.com' } = process.env;
const API_SUCCESS = 'success';
const HTTPS_HOSTS = ['api-dev.thehuddle.com', 'api-qa.thehuddle.com', 'api.thehuddle.com'];
let API_PROTOCOL = 'http'; // local dev should not require SSL setup
if (HTTPS_HOSTS.includes(API_HOST)) {
  API_PROTOCOL = 'https';
}
const API_PATH = '/api';
const API_VERSION = '/'; // TODO: should make use of versioning path
const TOKEN_COOKIE_NAME = 'session';

log("API_HOST", API_HOST);

const buildApiUrl = endpoint => (process.env.IS_BROWSER ? `${API_PATH}${API_VERSION}${endpoint}`
  : `${API_PROTOCOL}://${API_HOST}${API_VERSION}${endpoint}`);

const alwaysSendOptions = {
  credentials: 'include',
};

const SET_HEADERS = {
  'content-type': 'application/json',
};

const huddleRequester = ({ token }) => (endpoint, options = {}) =>
  new Promise(async (resolve, reject) => {
    log('making call using:', { endpoint, options });
    const headersToSend = new Headers();
    const { headers, ...otherOpts } = options;
    Object.entries(SET_HEADERS).forEach(([h, v]) => {
      headersToSend.set(h, v);
    });
    let url = '';
    try {
      url = buildApiUrl(endpoint);

      if (headers) {
        Object.entries(headers).forEach(([h, v]) => {
          if (SET_HEADERS[h.toLowerCase()]) {
            headersToSend.set(h, v);
          } else {
            headersToSend.append(h, v);
          }
        });
      }
      // this line prevents this code from making it into the client via webpack define
      if (!process.env.IS_BROWSER) {
        if (token) {
          headersToSend.append('Cookie', `${TOKEN_COOKIE_NAME}=${token}`);
        }
      }
      const sendOptions = {
        ...alwaysSendOptions,
        ...otherOpts,
        ...!!options.body && { body: JSON.stringify(options.body) },
      };
      sendOptions.headers = headersToSend;
      log('sending with headers:', JSON.stringify(headersToSend));

      const { response, ...data } = await request(url, sendOptions);
      if (!response) {
        return reject({
          status: 'failed',
          message: "We're sorry but something went wrong. Please try again and if you keep seeing this message, come back later or contact us using the form at the bottom of this page. (API: /"+endpoint+")",
          meta: {
            fullUrl: url,
          },
        });
      }

      if (API_SUCCESS !== response.status) {
        return reject({
          status: response.status || 'failed',
          message: response.message || "We're sorry but something went wrong. Please try again and if you keep seeing this message, come back later or contact us using the form at the bottom of this page. (API: /"+endpoint+")",
          email: response.email,
          meta: {
            fullUrl: url,
          },
        });
      }

      return resolve(data);
    } catch (reqError) {
      const { name, message, stack } = reqError;
      return reject({
        status: 'error',
        message,
        meta: {
          fullUrl: url,
          name,
          stack,
        },
      });
    }
  },
);

export default huddleRequester;



// WEBPACK FOOTER //
// ./src/lib/api/huddle-request.js